import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Button, Select } from "antd";
import { ToastError, ToastSuccess } from "../../components/ToastSwal";
import { UpdateMonthDetailDescription } from "../../api/APIProjectDescription";
const { Option } = Select;

const ModalEditMonthDescription = ({ 
    isOpen,
    onClose,
    month, 
    editMonthData,
    fetchData
 }) => {    
    const [loadings, setLoadings] = useState(false);
    const [form] = Form.useForm();

    // Reset fields và thiết lập giá trị mặc định khi editMonthData thay đổi
    useEffect(() => {
        if (editMonthData) {
            form.setFieldsValue({
                id_month_description: editMonthData.id || "",
                unit_price_total: editMonthData.unit_price_total || "",
                rsvn_to_rsjp: editMonthData.rsvn_to_rsjp || "",
                rsvn_to_rsjp_unit_price: editMonthData.rsvn_to_rsjp_unit_price || "",
            });
        } else {
            form.resetFields();
        }
    }, [editMonthData, form]);

    const RsvntoRsjpOptions = [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' },
    ]

    const handleOk = () => {
        form
            .validateFields()
            .then((values) => {                
                var FormData = require("form-data");
                var data = new FormData();
                setLoadings(!loadings);
                data.append("message", "detail");
                data.append("id", editMonthData.id);
                data.append("unit_price_total", values.unit_price_total);
                data.append("rsvn_to_rsjp", values.rsvn_to_rsjp);
                data.append("rsvn_to_rsjp_unit_price", values.rsvn_to_rsjp_unit_price);
                // Gọi API cập nhật dữ liệu
                UpdateMonthDetailDescription(data)
                    .then((res) => {
                        // console.log('log: ', res);
                        
                        if (res.data.message === "ok" ) {
                            ToastSuccess.fire({
                                icon: "success",
                                title: "Cập nhật Tháng Description thành công",
                            });
                            // form.resetFields();
                            // onClose(); // Đóng modal
                            fetchData(); // Fetch lại dữ liệu sau khi cập nhật
                        }
                        else {
                            ToastSuccess.fire({
                            icon: "error",
                            title: res?.data?.message,
                            });
                            setLoadings(false);
                        }
                    })
                    .catch((res) => {
                        ToastError.fire({
                            icon: "error",
                            title: res?.data?.message,
                        });
                    });
            })
            .catch((info) => {
                console.log("Validation Failed:", info);
            });
    };

    return (
        <Modal
            title={`Edit Data for Month ${month}`}
            open={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk}>
                    Save
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    name="unit_price_total"
                    label="Unit Price Total"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập Unit Price Total!"
                        },
                        {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: "Unit Price Total chỉ nhập số hoặc số thập phân!",
                        }
                    ]}
                >
                    <Input
                        placeholder="Unit Price Total"
                    />
                </Form.Item>
                <Form.Item
                    label="RSVN to RSJP"
                    name="rsvn_to_rsjp"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng chọn RSVN to RSJP!",
                        },
                    ]}
                >
                    <Select size="large" placeholder="RSVN to RSJP">
                        {RsvntoRsjpOptions.map((e) => (
                            <Option key={e.value} value={e.value}>
                                {e.label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name="rsvn_to_rsjp_unit_price"
                    label="RSVN to RSJP Unit Price"
                    rules={[
                        {
                            required: true,
                            message: "Vui lòng nhập RSVN to RSJP Unit Price!"
                        },
                        {
                            pattern: /^[0-9]+(\.[0-9]+)?$/,
                            message: "RSVN to RSJP Unit Price chỉ nhập số hoặc số thập phân!",
                        }
                    ]}
                >
                    <Input
                        placeholder="RSVN to RSJP Unit Price"
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalEditMonthDescription;
